import { getInitials } from '@/lib/utils'
import { cn } from '@/lib/utils'

const sizes = { xs: 'w-5 h-5 text-[9px]', sm: 'w-6 h-6 text-[10px]', md: 'w-7 h-7 text-xs', lg: 'w-8 h-8 text-sm', xl: 'w-10 h-10 text-base', '2xl': 'w-12 h-12 text-lg' }

export function Avatar({ user, size = 'md', className }) {
  if (user?.avatar) {
    return <img src={user.avatar} className={cn('rounded-full object-cover', sizes[size], className)} alt={user.name} />
  }
  return (
    <div className={cn('rounded-full bg-accent/20 text-accent flex items-center justify-center font-semibold flex-shrink-0', sizes[size], className)}>
      {getInitials(user?.name || '?')}
    </div>
  )
}
